// Build information, automatically generated by `ng-info`
const build = {
    version: "25.1.0",
    timestamp: "Wed Oct 28 2026 01:45:29 GMT+0100 (Central European Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "HEAD",
        hash: "364e08",
        fullHash: "364e08257afdcb6c5e5a5d00f0ddf6711c1762ee"
    }
};

export default build;